module.exports = __webpack_public_path__ + "img/7.723697fe.jpg";